(() => {
 'use strict';
 function prepare(scope=document){
  scope.querySelectorAll('[data-landing-hero]').forEach(hero=>{
   if(hero.dataset.prepared)return;hero.dataset.prepared='true';
   const title=hero.querySelector('[data-letter-title]');if(!title)return;
   const original=title.textContent.trim();let index=0;
   const accessible=document.createElement('span');accessible.className='visually-hidden';accessible.textContent=original;
   const visual=document.createElement('span');visual.setAttribute('aria-hidden','true');
   const step=Math.min(.04,1.6/Math.max(original.length,1));
   original.split(/\s+/).forEach((word,wordIndex)=>{
    if(wordIndex)visual.appendChild(document.createTextNode(' '));
    const part=document.createElement('span');part.className='lp-title-word';
    Array.from(word).forEach(letter=>{const span=document.createElement('span');span.className='lp-title-char';span.textContent=letter;span.style.setProperty('--letter-delay',`${index++*step}s`);part.appendChild(span);});visual.appendChild(part);
   });
   title.replaceChildren(accessible,visual);
   const book=index*step+.42,bonus=book+.95,usp=bonus+1.3;
   hero.style.setProperty('--book-delay',`${book}s`);hero.style.setProperty('--bonus-delay',`${bonus}s`);hero.style.setProperty('--usp-delay',`${usp}s`);
   hero.classList.add('lp-sequence-ready');
  });
 }
 prepare();document.addEventListener('shopify:section:load',event=>prepare(event.target));
})();
